"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyFundRequest = void 0;
var MyFundRequest = /** @class */ (function () {
    function MyFundRequest() {
    }
    return MyFundRequest;
}());
exports.MyFundRequest = MyFundRequest;
;
//# sourceMappingURL=myFund.request.js.map